export default "__VITE_ASSET__D3sQpb2Z__"